export const nameSpace = '@@/product-manager';
